import { render, staticRenderFns } from "./modifier.vue?vue&type=template&id=7fbc4856&scoped=true"
import script from "./modifier.vue?vue&type=script&lang=js"
export * from "./modifier.vue?vue&type=script&lang=js"
import style0 from "./modifier.vue?vue&type=style&index=0&id=7fbc4856&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc4856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbc4856')) {
      api.createRecord('7fbc4856', component.options)
    } else {
      api.reload('7fbc4856', component.options)
    }
    module.hot.accept("./modifier.vue?vue&type=template&id=7fbc4856&scoped=true", function () {
      api.rerender('7fbc4856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/itemConfig/modifier.vue"
export default component.exports